<template>
  <span>
    <v-btn
      block
      outlined
      :disabled="!validEdition"
      color="primary"
      class="pa-0"
      :class="{ 'primary-gradient': validEdition }"
      :large="showDisplayCurrency && !!productsTotal"
      @click="updateProduct()">
      <v-layout px-2 align-center justify-center>
        <template>
          <span v-text="$t('catalog.actions.update')" />
          <span v-if="productsTotal" class="show-spaces" v-text="' · '" />
        </template>
        <template v-if="productsTotal">
          <span class="d-flex flex-column align-start">
            <span color="primary--text" v-text="baseCurrencyPriceText" />
            <span v-if="showDisplayCurrency" class="grey--text" v-text="displayCurrencyPriceText" />
          </span>
        </template>
      </v-layout>
    </v-btn>
  </span>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import vuetifyMixins from '@/mixins/Vuetify'

export default {
  props: {
    validate: { type: Function, requied: true },
  },
  computed: {
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency', 'baseCurrency']),
    ...mapGetters({
      productsTotal: 'cart/productsTotal',
      mainStateProduct: 'cart/mainStateProduct',
      getBasicProductCartQuantity: 'cart/getBasicProductCartQuantity',
    }),
    ...mapState({
      quantity: ({ cart }) => cart.quantity,
      products: ({ cart }) => cart.products,
      cartProducts: ({ cart }) => cart.cartProducts,
    }),
    validEdition () {
      return (this.mainStateProduct && this.mainStateProduct.quantity) ||
        this.products
          .filter(stateProduct => stateProduct.isRelatedProduct)
          .some(stateProduct => stateProduct.quantity !== this.getBasicProductCartQuantity(stateProduct.product.id))
    },
    baseCurrencyPriceText () {
      return this.getPriceString({ amount: this.productsTotal, currency: this.baseCurrency })
    },
    displayCurrencyPriceText () {
      return this.getPriceString({ amount: this.productsTotal, currency: this.baseCurrency, displayCurrency: this.displayCurrency })
    },
  },
  methods: {
    updateProduct () {
      if (!this.validate()) return
      this.$store.commit('cart/updateCartProducts')
      this.$router.go(-1)
    },
  },
  mixins: [vuetifyMixins],
}
</script>
